import {
    handleActions,
    Action,
} from 'redux-actions';
import {
    MarkerTogglePayload,
    MARKER_SELECT_TOGGLE,
    MarkerSelectNextPreviousPayload,
    MARKER_SELECT_NEXT_PREVIOUS,
} from './TimelineActions';
import {TimelineRowType} from '../TimelineTypes';

export interface TimelineState {
    selectedMarkerId: string;
    selectedRowId: string;
    selectedType: TimelineRowType;
}

export const toggleSelectedMarker = (state: TimelineState, action: Action<MarkerTogglePayload>): TimelineState => {
    const {payload} = action;
    const {
        markerId,
        rowId,
        type,
    } = payload;
    
    if (!markerId && rowId) {
        const {selectedRowId} = state;
        
        if (selectedRowId === rowId)
            return initialState;
        
        return {
            selectedMarkerId: markerId,
            selectedRowId: rowId,
            selectedType: type,
        };
    }
    
    if (!markerId || !rowId) {
        return state;
    }
    
    const {selectedMarkerId} = state;
    
    if (markerId === selectedMarkerId) {
        return initialState;
    }
    
    return {
        selectedMarkerId: markerId,
        selectedRowId: rowId,
        selectedType: type,
    };
};

export const selectPreviousNextMarker = (state: TimelineState, action: Action<MarkerSelectNextPreviousPayload>): TimelineState => {
    const {payload} = action;
    const {markerId} = payload;
    const {selectedRowId} = state;
    
    if (!markerId || !selectedRowId) {
        return state;
    }
    
    return {
        ...state,
        selectedMarkerId: markerId,
    };
};

export const initialState: TimelineState = {
    selectedMarkerId: '',
    selectedRowId: '',
    selectedType: TimelineRowType.Unknown,
};

const handlers = {
    [MARKER_SELECT_TOGGLE]: toggleSelectedMarker,
    [MARKER_SELECT_NEXT_PREVIOUS]: selectPreviousNextMarker,
};

export default handleActions<TimelineState, MarkerTogglePayload>(handlers, initialState);
